///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2026
//                           RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

/** RXO server facets return enum/numeric IDs as strings; coerce before column format(). */
export const RXO_TL_NUMERIC_FACET_FIELDS = new Set([
  "pricingConfidence",
  "target",
  "targetType",
  "rateType",
  "customerFeedbackType",
  "awardType",
  "awardRank",
  "fuelSurchargeType",
  "equipmentTypeDetail",
  "equipmentType"
]);

export const matchesNumericEnumFacet = (optionValue, facetValue) =>
  optionValue === facetValue ||
  (typeof facetValue === "string" &&
    facetValue.trim() !== "" &&
    Number.isFinite(Number(facetValue)) &&
    optionValue === Number(facetValue) &&
    String(Number(facetValue)) === facetValue.trim());

export const coerceFacetValue = (field, v) => {
  if (v === undefined || v === null || v === "") {
    return v;
  }
  if (!RXO_TL_NUMERIC_FACET_FIELDS.has(field)) {
    return v;
  }
  if (typeof v === "number" && Number.isFinite(v)) {
    return v;
  }
  if (
    typeof v === "string" &&
    v.trim() !== "" &&
    Number.isFinite(Number(v)) &&
    String(Number(v)) === v.trim()
  ) {
    return Number(v);
  }
  return v;
};

export const formatEnumFacetLabel = (options, value) => {
  if (value === undefined || value === null || value === "") {
    return value === "" ? "" : value;
  }
  const row = options.find(f => matchesNumericEnumFacet(f.value, value));
  if (row) {
    return row.label;
  }
  return String(value);
};
